// extracted by mini-css-extract-plugin
module.exports = {"icons__socialicons":"icons_icons__socialicons__rrHfj"};